import Vue from 'vue';
//模块功能：关于我们-公司简介
export default Vue.extend({
    name: "index",
    data: function () {
        return {
            html: ''
        };
    },
    mounted: function () {
    },
    methods: {},
    computed: {
        contents: function () {
            var temp = this.$t("comprofile");
            var url = "../../../static/img/index/";
            for (var _i = 0, _a = temp['con']; _i < _a.length; _i++) {
                var item = _a[_i];
                item.img = url + item.img;
            }
            return temp;
        }
    }
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/iview-loader??ref--0-1!./src/sfc/about/index.vue
// module id = null
// module chunks = 